export const FETCH_LOCATIONS_RESOLVED = "FETCH_LOCATIONS_RESOLVED";
export const FETCH_LOCATION_RESOLVED = "FETCH_LOCATION_RESOLVED";
export const UPDATE_LOCATION_RESOLVED = "UPDATE_LOCATION_RESOLVED";
export const DELETE_LOCATION_LOG_RESOLVED = "DELETE_LOCATION_LOG_RESOLVED";
export const DELETE_LOCATION_RESOLVED = "DELETE_LOCATION_RESOLVED";
export const CREATE_LOCATION_RESOLVED = "CREATE_LOCATION_RESOLVED";
export const FETCH_LOCATIONS_PERSONABLES_RESOLVED =
  "FETCH_LOCATIONS_PERSONABLES_RESOLVED";
export const FETCH_LOCATIONS_NAMES_RESOLVED = "FETCH_LOCATIONS_NAMES_RESOLVED";
